import * as React from 'react';
import { MessageOutlined } from '@ant-design/icons';
import { message } from 'antd';
import Button from 'common/components/Button';
import * as intl from "react-intl-universal";

interface iProp {
    lang?: 'zh-CN' | 'zh-TW' | 'en-US' | 'ko-KR' | 'ja-JP' | 'vi-VN' | 'th-TH' | 'in-ID';
    call: Function;
    time?: number;
    disabled?: boolean;
    size?: 'small' | 'large';
    style?: object;
    formatFn?: Function;
    timeout?:Function;
}

interface iState {
    status: 'Send' | 'Sending' | 'Sent' | 'ReSend';
    elapsed: number;
}

export default class SendCode extends React.Component<iProp> {
    static defaultProps = {
        lang: 'zh-CN',
        time: 60,
        disabled: false
    };

    private locales = {
        'zh-CN': {
            Send: '发送验证码',
            Sending: '正在发送...',
            Sent: '重新发送({elapsed}s)',
            ReSend: '重新发送'
        },
        'zh-TW': {
            Send: '發送驗證碼',
            Sending: '正在發送...',
            Sent: '重新發送({elapsed}s)',
            ReSend: '重新發送'
        },
        'en-US': {
            Send: 'Send Code',
            Sending: 'Sending...',
            Sent: 'ReSend({elapsed}s)',
            ReSend: 'ReSend'
        },
        'ko-KR': {
            Send: 'Send Code',
            Sending: 'Sending...',
            Sent: 'ReSend({elapsed}s)',
            ReSend: 'ReSend'
        },
        'ja-JP': {
            Send: 'Send Code',
            Sending: 'Sending...',
            Sent: 'ReSend({elapsed}s)',
            ReSend: 'ReSend'
        },
        'vi-VN': {
            Send: 'Send Code',
            Sending: 'Sending...',
            Sent: 'ReSend({elapsed}s)',
            ReSend: 'ReSend'
        },
        'th-TH': {
            Send: 'ส่งรหัสยืนยัน',
            Sending: 'กำลังส่ง',
            Sent: 'ส่งใหม่({elapsed}s)',
            ReSend: 'ส่งใหม่'
        },
        'in-ID': {
            Send: 'Kirim kode verifikasi',
            Sending: 'Sedang mengirim',
            Sent: 'Kirim ulang({elapsed}s)',
            ReSend: 'Kirim ulang'
        }
    };

    state: iState = {
        status: 'Send',
        elapsed: 0
    };

    componentWillUnmount() {
        // clear the interval if timer is there
        this.timer !== null && clearInterval(this.timer);
    }

    timer: any = null;

    // send action
    send = async () => {
        const { call, formatFn } = this.props;
        if (!formatFn || (formatFn && formatFn())) {
            // set state 'sending'
            this.setState({
                status: 'Sending',
                elapsed: 0
            });
            try {
                // call action
                await call();
                // set state 'sent'
                this.setState({
                    status: 'Sent'
                });
                // set interval
                this.timer = setInterval(this.elapsedHandler, 1000);
            } catch (err) {
                let msgKey = '';
                switch (err.code) {
                    case 2020:
                        msgKey = 'Error.ImgCodeVerifyError';
                        break;
                    case 2021:
                        msgKey = 'Error.ImgCodeVerifyExpireError';
                        break;
                    default:
                        msgKey = 'Hint.SendError';
                        break;
                }
                message.error(intl.get(msgKey));
                clearInterval(this.timer);
                this.setState({
                    status: 'ReSend',
                    elapsed: 0
                });
            }
        }

    };

    // time elapsed handler
    elapsedHandler = () => {
        const { time } = this.props;
        const { elapsed } = this.state;
        if (elapsed === time) {
            // destroy the interval if elapsed time is reached
            clearInterval(this.timer);
            // set state 'resend'
            this.setState({
                status: 'ReSend'
            });
        } else {
            // set state elapsed time
            this.setState({
                elapsed: elapsed + 1
            });
        }
        // 提供一个回调hook
        this.props.timeout && this.props.timeout();
    };

    render() {
        const { lang, time, disabled, size, style } = this.props;
        const { status, elapsed } = this.state;
        // lock if status is sending or sent
        const lock = disabled || (status === 'Sending' || status === 'Sent');
        const text = this.locales[lang][status];
        return (
            <Button className="SendCode" size={size} onClick={this.send} disabled={lock} style={style}>
                <MessageOutlined />{status === 'Sent' ? text.replace(/{elapsed}/, (time - elapsed).toString()) : text}
            </Button>
        );
    }
}
